import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'videoResolution',
  standalone: true,
  pure: true,
})
export class VideoResolutionPipe implements PipeTransform {
  transform(data: { width?: number; height?: number }): string {
    if (!data) return;
    const p = Math.min(data.width, data.height);
    if (p === 718) return '720p'; // hardcode 720p because we send 718 to mediaconvert as a cost-saving measure
    return `${p}p`;
  }
}
